(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["text-with-icons"] && !Shopify.designMode) return;
  try {
    
  customElements.whenDefined('text-with-icons-carousel').then(() => {
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const desktop = matchMedia('(min-width: 700px)');
    const controllers = new WeakMap();
    const initialize = (root) => {
      root.querySelectorAll('[data-mn-services-autoplay]').forEach((carousel) => {
        if (controllers.has(carousel)) return;
        const section = carousel.closest('.shopify-section');
        const toggle = section.querySelector('.mn-services-toggle');
        const controller = new AbortController();
        const options = { signal: controller.signal };
        let visible = false;
        let hovered = false;
        let paused = false;
        const sync = () => {
          const focused = document.activeElement !== toggle && section.contains(document.activeElement);
          const blocked = !carousel.isConnected || !visible || desktop.matches || reduced.matches || document.hidden || hovered || focused || paused;
          if (blocked) carousel.player?.stop();
          else carousel.player?.start();
          if (desktop.matches) {
            carousel.cleanUpAnimations();
            carousel.allCells.forEach((cell) => cell.style.removeProperty('transform'));
          }
          toggle.hidden = reduced.matches;
          toggle.dataset.paused = String(paused);
          toggle.setAttribute('aria-label', paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
        };
        const observer = new IntersectionObserver((entries) => {
          const latest = entries[entries.length - 1];
          visible = latest.isIntersecting && latest.intersectionRatio >= .4;
          sync();
        }, { threshold: [0, .4] });
        const scheduleSync = () => queueMicrotask(sync);
        carousel.player?.stop();
        observer.observe(carousel);
        carousel.addEventListener('carousel:settle', sync, options);
        section.addEventListener('pointerenter', (event) => { if (event.pointerType === 'mouse') { hovered = true; sync(); } }, options);
        section.addEventListener('pointerleave', (event) => { if (event.pointerType === 'mouse') { hovered = false; sync(); } }, options);
        section.addEventListener('focusin', sync, options);
        section.addEventListener('focusout', scheduleSync, options);
        document.addEventListener('visibilitychange', sync, options);
        desktop.addEventListener('change', scheduleSync, options);
        reduced.addEventListener('change', sync, options);
        toggle.addEventListener('click', () => { paused = !paused; sync(); }, options);
        const destroy = () => { carousel.player?.stop(); observer.disconnect(); controller.abort(); controllers.delete(carousel); };
        controllers.set(carousel, destroy);
        window.addEventListener('pagehide', () => carousel.player?.stop(), options);
        window.addEventListener('pageshow', sync, options);
        sync();
      });
    };
    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-mn-services-autoplay]').forEach((carousel) => controllers.get(carousel)?.());
    });
  });

  } catch(e) { console.error(e); }
})();
})();
